/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Error_Deleting_Translation_FileInputs */

const en_error_deleting_translation_file = /** @type {(inputs: Error_Deleting_Translation_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error deleting translation file: ${i?.error}`)
};

const fr_error_deleting_translation_file = /** @type {(inputs: Error_Deleting_Translation_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de la suppression du fichier de traduction : ${i?.error}`)
};

const de_error_deleting_translation_file = /** @type {(inputs: Error_Deleting_Translation_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Löschen der Übersetzungsdatei: ${i?.error}`)
};

const it_error_deleting_translation_file = /** @type {(inputs: Error_Deleting_Translation_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante l'eliminazione del file di traduzione: ${i?.error}`)
};

const ru_error_deleting_translation_file = /** @type {(inputs: Error_Deleting_Translation_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при удалении файла перевода: ${i?.error}`)
};

const es_error_deleting_translation_file = /** @type {(inputs: Error_Deleting_Translation_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al eliminar el archivo de traducción: ${i?.error}`)
};

const zh_cn2_error_deleting_translation_file = /** @type {(inputs: Error_Deleting_Translation_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除翻译文件时出错：${i?.error}`)
};

const ja_error_deleting_translation_file = /** @type {(inputs: Error_Deleting_Translation_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`翻訳ファイルの削除中にエラーが発生しました: ${i?.error}`)
};

const hi_error_deleting_translation_file = /** @type {(inputs: Error_Deleting_Translation_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अनुवाद फ़ाइल को हटाने में त्रुटि: ${i?.error}`)
};

const pt_pt2_error_deleting_translation_file = /** @type {(inputs: Error_Deleting_Translation_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao excluir o arquivo de tradução: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error deleting translation file: {error}" |
*
* @param {Error_Deleting_Translation_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_deleting_translation_file = /** @type {((inputs: Error_Deleting_Translation_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Deleting_Translation_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_deleting_translation_file(inputs)
	if (locale === "de") return de_error_deleting_translation_file(inputs)
	if (locale === "it") return it_error_deleting_translation_file(inputs)
	if (locale === "ru") return ru_error_deleting_translation_file(inputs)
	if (locale === "es") return es_error_deleting_translation_file(inputs)
	if (locale === "zh-CN") return zh_cn2_error_deleting_translation_file(inputs)
	if (locale === "ja") return ja_error_deleting_translation_file(inputs)
	if (locale === "hi") return hi_error_deleting_translation_file(inputs)
	if (locale === "pt-PT") return pt_pt2_error_deleting_translation_file(inputs)
	return en_error_deleting_translation_file(inputs)
});